import React from 'react';
import { useTranslation } from 'react-i18next';
import Hint from './hint';

interface Props {
  onClick: () => void;
  className: string;
}

const TEXT_TRANSLATION_KEY = 'signup-flow.domain.transfer.hint.domain_is_transferable.text';
const CTA_TRANSLATION_KEY = 'signup-flow.domain.transfer.hint.domain_is_transferable.cta';

const TransferDomainTransferableHint: React.SFC<Props> = (props) => {
  const { t } = useTranslation();

  const text = t(TEXT_TRANSLATION_KEY);
  const ctaText = t(CTA_TRANSLATION_KEY);

  return <Hint className={props.className} html={text} ctaText={ctaText} />;
};

export default TransferDomainTransferableHint;
